import { router } from '@/router'
import { PAGE_NAME, PAGE_HOME } from '@/enums'
import { RouteParams, RouteQueryAndHash } from 'vue-router'

// 静态
export function goHome({ replace = false } = {}) {
  return router.push({ name: PAGE_HOME, replace, params: {} })
}
export function goLogin({ replace = false } = {}) {
  router.push({ name: PAGE_NAME.LOGIN, replace })
}
export function go404() {
  router.push({ name: PAGE_NAME.PAGE_NOT_FOUND })
}
export function goBack() {
  router.back()
}
export function isInHome(routeName: string) {
  return routeName == PAGE_HOME
}

export const openNewTab = (url: string) => {
  window.open(url, '_blank')
}

export const VideoDetailTypeList = ['clip', 'oral', 'storyIndex'] as const
export const toVideoDetail = (
  opt: { md5: string; type?: (typeof VideoDetailTypeList)[number]; id?: string | number },
  replace = true
) => {
  const { md5, type, id } = opt
  const currentRoute = router.currentRoute.value
  const query: Record<string, any> = { ...currentRoute.query }
  if (type && id) {
    query[type] = id
  }

  if (currentRoute.meta.videoDetail && currentRoute.name !== PAGE_NAME.INSIGHT_LIST) {
    return router.push({ name: currentRoute.name!, query: { md5, ...query }, replace })
  }

  router.push({ name: PAGE_NAME.INSIGHT_LIST, params: { videoMd5: md5 }, query, replace })
}

export const openNewTabWithRouter = (
  name: PAGE_NAME,
  opts?: { query?: RouteQueryAndHash['query']; params?: RouteParams }
) => {
  const url = router.resolve({
    name,
    ...opts,
  })
  openNewTab(url.href)
}

export const goPush = (name: PAGE_NAME, opts?: { query?: RouteQueryAndHash['query']; params?: RouteParams }) => {
  router.push({
    name,
    ...opts,
  })
}
export const goReplace = (name: PAGE_NAME, opts?: { query?: RouteQueryAndHash['query']; params?: RouteParams }) => {
  router.replace({
    name,
    ...opts,
  })
}
